module.exports = __webpack_public_path__ + "static/activityIcon2.c9cf887e.png";